import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Performance from "@/components/Performance";
import Services from "@/components/Services";
import LeadMagnet from "@/components/LeadMagnet";
import IdealClient from "@/components/IdealClient";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import PerformancePage from "@/pages/PerformancePage";
import ContactPage from "@/pages/ContactPage";
import ConsultingPage from "@/pages/ConsultingPage";
import HyroxGuidePage from "@/pages/HyroxGuidePage";
import SlideInLeadCard from "@/components/SlideInLeadCard";
import { useSeo } from "@/hooks/useSeo";

const Site = () => {
  const location = useLocation();

  useSeo({
    title: "Smith Strategic Group | Performance Coaching and Strategic Consulting",
    description:
      "Smith Strategic Group helps ambitious professionals and organizations build stronger systems, improve performance, and execute with clarity. Explore performance coaching and strategic consulting.",
    path: "/",
  });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location.hash]);

  return (
    <div className="App font-body antialiased text-neutral-950 bg-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Performance />
        <Services />
        <LeadMagnet />
        <IdealClient />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "0.02em",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/performance" element={<PerformancePage />} />
        <Route path="/strategic-consulting" element={<ConsultingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/hyrox-race-prep-guide" element={<HyroxGuidePage />} />
        <Route path="/apply" element={<Navigate to="/performance#apply" replace />} />
        <Route path="*" element={<Site />} />
      </Routes>
      <SlideInLeadCard />
    </BrowserRouter>
  );
}

export default App;
